import * as faker from 'faker';
import * as moment from 'moment';

import * as helpers from './helpers';

const carriers = {};
const defaultCarrierId = 45237;
for (let id = defaultCarrierId; id < defaultCarrierId + 75; id++) {
    carriers[id] = {
        id,
        name: faker.company.companyName(),
        scac: faker.random.alphaNumeric(4),

        leadTimeWindowMinutes: faker.random.number({min: 1, max: 48}) * 60,

        ratingPhoneNumber: faker.phone.phoneNumber('1(###) 555-01##'),
        dispatchPhoneNumber: faker.phone.phoneNumber('1(###) 555-01##'),
        customerServicePhoneNumber: faker.phone.phoneNumber('1(###) 555-01##'),

        ratingUrl: 'http://example.com/rating',
        dispatchUrl: 'http://example.com/dispatch',

        insuranceProvider: faker.company.companyName(),
        insurancePolicyNumber: faker.finance.iban(),
        insuranceExpirationDate: moment(faker.date.future(3)),

        p44AccountCode: faker.finance.bic(),
        usDotNumber: faker.finance.account(),
        mcNumber: faker.finance.account(),
        dunsNumber: faker.finance.account(),
        federalEinNumber: faker.finance.account(),
    };
}

export const mocks = {
    EPro: () => ({
        isDeleted: false,
        suspended: false,

        name: faker.company.bs(2),
        format: 'T#########@',
    }),

    EProSequenceInfo: () => ({
        archived: false,
        exhausted: false,
        sequenceStart: '180000000',
        lastValueUsed: '185208126',
        sequenceEnd: '189999999',
        sequenceGuid: faker.random.uuid(),
    }),

    CarrierOnTimeStat: () => ({
        carrierName: faker.company.companyName(),
        scac: faker.random.alphaNumeric(4),
        percentOnTimeForDelivery: faker.random.number({min: 80, max: 100, precision: 2}),
        percentOnTimeForPickup: faker.random.number({min: 80, max: 100, precision: 2}),
        numDelivered: faker.random.number({min: 15, max: 250}),
        numPickedUp: faker.random.number({min: 15, max: 250}),
        numLateDeliveries: faker.random.number({min: 0, max: 12}),
        numLatePickups: faker.random.number({min: 0, max: 12}),
    }),

    RemittanceCarrierItem: () => ({
        glCode: faker.finance.bic(),
        proNumber: faker.finance.bic(),

        // IDs taken from src/uitl/testHelpers.js mockInvoiceData
        invoiceId: faker.random.arrayElement([
            1234567890,
            8172619232,
            9654278188,
            6667612281,
            9887123476,
            98654123476,
            88854123476,
            11288212312,
        ]),
    }),

    RemittanceCarrierBatch: () => ({
        carrierName: faker.company.companyName(),
        scac: faker.random.alphaNumeric(4),

        invoiceCount: 15,
        carrierItems: helpers.repeat(15, mocks.RemittanceCarrierItem),
    }),

    RemittanceBatchQueries: () => ({
        carrierBatches: helpers.mockPagedQuery(75, mocks.RemittanceCarrierBatch),
    }),
};




export const resolvers = {
    CarrierQueries: {
        byId: (root, {id}) => carriers[id],
        all: () => Object.values(carriers),
        paged: helpers.pagedQuery(() => Object.values(carriers)),
        onTimeStats: () => helpers.repeat(15, mocks.CarrierOnTimeStat),

        // used by the Top Carriers dashboard
        carrierSpend: (root, {}) => {
            let netAmount = faker.finance.amount('644.15', '19382.83');
            let netCount = faker.random.number({min: 15, max: 75});
            let carriers = [];

            for (let idx = 0; idx < 4; idx++) {
                let amount = faker.finance.amount(
                    netAmount * 0.25,
                    netAmount * 0.5
                );
                netAmount -= amount;

                let count = faker.random.number({
                    min: netCount * 0.2,
                    max: netCount * 0.6,
                });
                netCount -= count;

                carriers.push({
                    carrierName: faker.company.companyName(0),
                    totalShipments: count,
                    totalSpend: +amount,
                })
            }

            return carriers;
        },
    },

    EProQueries: {
        all: () => helpers.repeat(75, mocks.EPro),
        byCarrierId: () => helpers.repeat(4, mocks.EPro),
        byId: () => ({}),
        paged: helpers.mockPagedQuery(75, mocks.EPro),
    },
};
